if (window.scrollY === undefined) {
    Object.defineProperty(window, 'scrollY', {
        get: function () { return window.pageYOffset; },
    });
}
